// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.forgot-pass[data-v-a238b9ca] {\n  display: block;\n  width: 100%;\n}\n.forgot-pass__content-wrapper[data-v-a238b9ca] {\n  display: block;\n  width: 100%;\n  margin: 0 auto;\n}\n", ""]);
// Exports
module.exports = exports;
